import { render, staticRenderFns } from "./TiptapEditor.vue?vue&type=template&id=5801ec3a"
import script from "./TiptapEditor.vue?vue&type=script&lang=js"
export * from "./TiptapEditor.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/animations.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./TiptapEditor.vue?vue&type=style&index=1&id=5801ec3a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports